import { MUSICIAN_DETAIL } from "constants/routes";
import { serviceRoles } from "config/access";
import { checkAccess } from "helpers/auth";
import MusicianPage from "./container/MusicianPage";

export default function getSettingsRoute(userAuth) {
  const { account, rhapsody } = serviceRoles;
  const requireAuth = {
    [rhapsody.name]: [account.roles.user],
    [account.name]: [account.roles.superadmin],
  };
  return {
    requireAuth,
    onEnter: () => checkAccess(requireAuth, userAuth),
    path: MUSICIAN_DETAIL,
    withSidebar: true,
    withAppBar: true,
    component: MusicianPage,
  };
}
